import React, { Fragment, useState } from 'react';
import FinancialProductWarrantiesEditContainer from './FinancialProductWarrantiesEditContainer';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from 'utils/functions';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_FINANCIAL_PRODUCT_WRITE, ADMIN_FINANCIAL_PRODUCT_READ } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const productId = match.params.id && getInt(match.params.id);
  const leasingFinancialProductXWarrantyId = match.params.leasingFinancialProductXWarrantyId && getInt(match.params.leasingFinancialProductXWarrantyId);
  const [title, setTitle] = useState('');

  const permissionRead = usePermission(ADMIN_FINANCIAL_PRODUCT_READ);
  const permissionWrite = usePermission(ADMIN_FINANCIAL_PRODUCT_WRITE);


  const onClickClose = () => {
    historyContext.push(`/financialProducts/${productId}`, { from: 'Warranties' });
  };

  const onChangeTitle = title => {
    setTitle(title);
  };

  const onRedirect = leasingFinancialProductXWarrantyId => {
    historyContext.push(`/financialProducts/${productId}/warranties/${leasingFinancialProductXWarrantyId}`);
  };

  return permissionRead || permissionWrite ? (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} />
      </Portal>
      <FinancialProductWarrantiesEditContainer
        canWrite={permissionWrite}
        productId={productId}
        leasingFinancialProductXWarrantyId={leasingFinancialProductXWarrantyId}
        onRedirect={onRedirect}
        onChangeTitle={onChangeTitle}
      />
    </Fragment>
  ) : (
    <></>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
